import { withBrowserContext } from '../../src/FiverrContext/withBrowserContext';
import BaseExperiment, { Variant, Control } from '../../src/Experiment';

export const Experiment = withBrowserContext(BaseExperiment);

export { Variant, Control };
